import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Img3 from '../assets/img3.jpg';
import ImgSuperRedeMaxCenter from '../assets/img1-supredemaxcenter.jpg';
import ImgSalvadorBrazil from '../assets/img1-salvadorbrazilfreeshop.jpg';
import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md'; // Ícones para as setas
import './newportfolio.css';




const imagesPort = [
  { src: Img3, title: "Posto Friderichs", route: "/postofriederichs" },
  { src: ImgSuperRedeMaxCenter, title: "Super Rede Max Center", route: "/superredemaxcenter" },
  { src: ImgSalvadorBrazil, title: "Salvador Brazil Free Shop", route: "/salvadorbrazilfreeshop" }

];

const NewPortfolio = () => {
  const [currentPortSlide, setCurrentPortSlide] = useState(0);

  const nextPortSlide = () => {
    setCurrentPortSlide((prev) => (prev === imagesPort.length - 1 ? 0 : prev + 1));
  };

  const prevPortSlide = () => {
    setCurrentPortSlide((prev) => (prev === 0 ? imagesPort.length - 1 : prev - 1));
  };

  useEffect(() => {
    console.log("Slide atual:", currentPortSlide);
    const intervalPort = setInterval(() => {
      setCurrentPortSlide((prev) => (prev === imagesPort.length - 1 ? 0 : prev + 1));
    }, 5000);
  
    return () => clearInterval(intervalPort);
  }, [currentPortSlide]);

  return (
    <div className="carousel">
  <div
    className="slide active"
    style={{ backgroundImage: `url(${imagesPort[currentPortSlide].src})` }}
  >
    <div className="overlay">
      <div className="overlay-layer"></div>
      <div className="overlay-content">
        <div className="top-left-store">
          <div className="info-box">
            <p className="info-text">
              Veja mais sobre a loja <br />
              <strong className="highlighted-text">{imagesPort[currentPortSlide].title}</strong>
            </p>
            <Link to={imagesPort[currentPortSlide].route}>
              <button className="info-btn">Ver mais</button>
            </Link>
          </div>
        </div>
        {/* Botões de navegação */}
        <div className="carousel-nav">
              <button onClick={prevPortSlide} className="prev-btn">
                <MdNavigateBefore size={40} />
              </button>
              <button onClick={nextPortSlide} className="next-btn">
                <MdNavigateNext size={40} />
              </button>
            </div>
      </div>
    </div>
  </div>
</div>

  
  );
};

export default NewPortfolio;
